import axios from 'axios'
import cookie from "cookie.js";
import { showNotify, closeNotify } from 'vant';
import router from "../router";

export const http = axios.create({
    baseURL: 'https://www.bolanzg.com',
    timeout: 5000,
    headers: {
      'tenant-id': 1
    }
})

// 添加请求拦截器
http.interceptors.request.use(
    function (config) {
        // const { accessToken, tenantId } = store.state.login
        const accessToken = cookie.get("accessToken");
        const tenantId = cookie.get("tenantId");
        Object.assign(config.headers, {
            Authorization: accessToken,
            "tenant-id": "1",
        });
        return config;
    },
    function (error) {
        return Promise.reject(error);
    }
);

const notRedirectUrl = [
    "/app-api/system/user/profile/get",
    "/app-api/member/user/get",
];
// 添加响应拦截器
http.interceptors.response.use(
    function (response) {
        if (response.status == 200) {
            if (response.data.code == 0) {
                return response.data.data;
            } else if (response.data.code == 401) {
                if (router.currentRoute.value.path == "/login")
                    return Promise.reject(response.data.msg);
                //登录失效
                cookie.remove("accessToken", { path: "/" });
                cookie.remove("tenantId", { path: "/" });
                showNotify({
                    message: response.data.msg,
                    type: "warning",
                });
                if (!notRedirectUrl.includes(response.config.url)) {
                    //设置完 cookie 需要刷新页面才会生效，因此需要跳转的方式
                    window.location.href =
                        "/login?path=" +
                        encodeURIComponent(router.currentRoute.value.fullPath);
                }
                // router.replace({
                //     path: '/workbench/login',
                //     query: { path: encodeURIComponent(router.currentRoute.value.path) }
                // })
                return Promise.reject(response.data.msg);
            } else {
                showNotify({
                    message: response.data.msg,
                    type: "warning",
                });
                return Promise.reject(response.data.msg);
            }
        } else {
            showNotify({
                message: "请求出错",
                type: "error",
            });
            return Promise.reject();
        }
    },
    function (error) {
        return Promise.reject(error);
    }
);